// src/components/store/sections/newsletter/NewsletterV85CyberconsoleEmeraldMint.tsx
"use client";

import React from "react";
import DynamicNewsletterVariant from "./DynamicNewsletterVariant";

export default function NewsletterV85CyberconsoleEmeraldMint(props: any) {
  return (
    <DynamicNewsletterVariant
      variantNumber={85}
      archKey="cyber_console"
      archLabel="Cyber Neon Console"
      palName="EmeraldMint"
      grad="from-emerald-500 via-teal-500 to-emerald-700"
      lightBg="bg-emerald-50"
      textCol="text-emerald-700"
      borderCol="border-emerald-200"
      btnCls="bg-emerald-600 hover:bg-emerald-700"
      hexCol="#10b981"
      {...props}
    />
  );
}
